import { IEdgeDevice } from "@store/assets/types";
import listDevices from "./listDevices";
import restartGreengrass from "./restartGreengrass";
import { EdgeDeviceStatus, listEdgeDeviceStatus } from "./listEdgeDeviceStatus";
import changeEdgeDeviceSite from "./changeEdgeDeviceSite";

export interface IDevice {
  listDevices(filter: "All" | "Available", siteId?: string, companyId?: string ): Promise<IEdgeDevice[]>;
  restartGreengrass(iotThingName: string): Promise<void>;
  listEdgeDeviceStatus(iotThingName: string): Promise<EdgeDeviceStatus[]>;
  changeEdgeDeviceSite(iotThingName: string, companyId: string, siteId: string): Promise<void>;
}

const EdgeDevices: IDevice = {
  listDevices,
  restartGreengrass,
  listEdgeDeviceStatus,
  changeEdgeDeviceSite
}

export default EdgeDevices;
